import { Injectable } from "@angular/core";
//import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Student } from '../models/student';
import { Observable } from "rxjs";
import { addDoc, collection, collectionData, deleteDoc, doc, docData, Firestore, getDoc, getDocs, orderBy, query, updateDoc } from '@angular/fire/firestore';

@Injectable()
export class StudentService {

    constructor(
      private firestore: Firestore
    ) {    }

    async readAsync (sectionId: string): Promise<{id: string, counterValue: number, data: Student}[]> {
      const studentsCollectionRef = collection(this.firestore, `sections/${sectionId}/students`);
      const studentsQuery = query(studentsCollectionRef, orderBy('fatherName', 'asc'));

      const snapshot = await getDocs(studentsQuery);
      return snapshot.docs.map((doc, index) => {
        return { id: doc.id, counterValue: (index++ + 1), data: doc.data() as Student };
      });
    }

    async readByIdAsync (sectionId: string, studentId: string): Promise<Student> {
      const studentDocRef = doc(this.firestore, `sections/${sectionId}/students/${studentId}`);
      const studentSnapshot = await getDoc(studentDocRef);

      if (studentSnapshot.exists()) {
        return studentSnapshot.data() as Student;
      } else {
        throw new Error('Student not found');
      }

    }

    async createAsync (sectionId: string, student: Student): Promise<string> {
        const studentsCollectionRef = collection(this.firestore, `sections/${sectionId}/students`);
        const docRef = await addDoc(studentsCollectionRef, { name: student.name, fatherName: student.fatherName, motherName: student.motherName });
        return docRef.id; // Return the ID of the newly created student
    }

    update(sectionId: string, studentId: string, student: Student): Promise<void> {
        const studentDocRef = doc(this.firestore, `sections/${sectionId}/students/${studentId}`);
        return updateDoc(studentDocRef, { name: student.name, fatherName: student.fatherName, motherName: student.motherName });
    }

    delete(sectionId: string, studentId: string): Promise<void> {
        const studentDocRef = doc(this.firestore, `sections/${sectionId}/students/${studentId}`);
        return deleteDoc(studentDocRef);
    }

    /*Get all sections filtered by year */
    //getBySection(sectionRef) {

        // return this.studentsCollection = this.db.collection<Student>('students', ref => {
        //     return ref.where("sectionRef", "==", sectionRef)
        //   });
    //}
}
